/**
 * Formeya mega menü v4 — URL anahtarlı eşleşme (sıra/isim değişince görsel doğru kalır)
 */
(function () {
  const MQ = window.matchMedia('(min-width: 990px)')
  const RETRY_MS = [0, 80, 250, 700, 1500, 3500]

  function readConfig() {
    const el = document.getElementById('formeya-mega-menu-data')
    if (!el?.textContent?.trim()) return { promo: null, menus: {} }
    try {
      return JSON.parse(el.textContent)
    } catch {
      return { promo: null, menus: {} }
    }
  }

  function normalizePath(href) {
    if (!href) return ''
    try {
      const u = new URL(href, window.location.origin)
      const p = u.pathname.replace(/\/+$/, '')
      return p || '/'
    } catch {
      return String(href).split('?')[0].split('#')[0].replace(/\/+$/, '') || '/'
    }
  }

  function topLinkHref(grid) {
    const item = grid.closest('.menu-list__list-item')
    if (!item) return ''
    const link = item.querySelector(':scope > a.menu-list__link, :scope > .menu-list__link')
    return link ? link.getAttribute('href') || '' : ''
  }

  function lookupMenuEntry(cfg, path) {
    if (!path || !cfg.menus) return null
    if (cfg.menus[path]) return cfg.menus[path]
    const keys = Object.keys(cfg.menus)
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i]
      if (k.startsWith('MegaMenuList-')) continue
      if (path === k || path.endsWith(k) || k.endsWith(path)) return cfg.menus[k]
    }
    return null
  }

  function imgSrc(url) {
    if (!url) return ''
    if (url.startsWith('//')) return 'https:' + url
    return url
  }

  function buildMediaCard(media) {
    if (!media?.image) return null
    const a = document.createElement('a')
    a.className = 'fm-mega-media'
    a.href = media.href || '#'
    const img = document.createElement('img')
    img.src = imgSrc(media.image)
    img.alt = media.imageAlt || media.label || ''
    img.loading = 'lazy'
    img.width = 240
    img.height = 180
    if (media.fallback) {
      img.addEventListener('error', function onErr() {
        img.removeEventListener('error', onErr)
        img.src = imgSrc(media.fallback)
      })
    }
    const wrap = document.createElement('span')
    wrap.className = 'fm-mega-media__img'
    wrap.appendChild(img)
    a.appendChild(wrap)
    if (media.label) {
      const lbl = document.createElement('span')
      lbl.className = 'fm-mega-media__label'
      lbl.textContent = media.label
      a.appendChild(lbl)
    }
    return a
  }

  function buildPromo(promo, opts) {
    if (!promo) return null
    const showImage = opts?.showImage !== false
    const a = document.createElement('a')
    a.className = 'fm-mega-promo' + (showImage ? '' : ' fm-mega-promo--text')
    a.href = promo.href || '#'
    const parts = []
    if (promo.image && showImage) {
      parts.push(
        '<span class="fm-mega-media__img fm-mega-promo__media"><img src="' +
          imgSrc(promo.image) +
          '" alt="' +
          (promo.imageAlt || promo.title || '') +
          '" loading="lazy" width="200" height="150"></span>',
      )
    }
    parts.push('<span class="fm-mega-promo__eyebrow">Empfehlung</span>')
    parts.push(
      '<span class="fm-mega-promo__title">' + (promo.title || '') + '</span>',
      '<span class="fm-mega-promo__text">' + (promo.text || '') + '</span>',
      '<span class="fm-mega-promo__cta">' + (promo.cta || 'Entdecken') + ' →</span>',
    )
    a.innerHTML = parts.join('')
    return a
  }

  function collectLinks(column) {
    return [...column.querySelectorAll('a.mega-menu__link')]
  }

  function stripThemeMedia(grid) {
    grid.querySelectorAll('.mega-menu__content, .mega-menu__content-list').forEach(function (el) {
      el.remove()
    })
    grid.querySelectorAll('img').forEach(function (img) {
      if (img.closest('.fm-mega-media, .fm-mega-promo')) return
      const src = img.getAttribute('src') || img.src || ''
      const inThemeFeatured = !!img.closest('.mega-menu__content, .mega-menu__content-list')
      if (
        src.includes('Aufbewahrungstaschen.png') ||
        inThemeFeatured ||
        (img.complete && img.naturalWidth === 0 && !img.closest('.fm-mega-media'))
      ) {
        img.remove()
      }
    })
  }

  function applyGridFallback(column, cols) {
    column.style.setProperty('display', 'grid', 'important')
    column.style.setProperty('grid-template-columns', cols, 'important')
    column.style.setProperty('gap', '1rem', 'important')
    column.style.setProperty('width', 'max-content', 'important')
    column.style.setProperty('flex-direction', 'unset', 'important')
  }

  function enhanceWideGrid(grid, entry, promo) {
    const column = grid.querySelector('.mega-menu__column')
    if (!column) return false
    const links = collectLinks(column)
    if (links.length < 2) return false

    if (grid.dataset.fmMegaReady === '1' && grid.querySelector('.fm-mega-bettwasche__column')) return true
    if (grid.dataset.fmMegaReady === '1') delete grid.dataset.fmMegaReady

    grid.dataset.fmMegaReady = '1'
    grid.classList.add('fm-mega-bettwasche')
    stripThemeMedia(grid)
    column.classList.add('fm-mega-bettwasche__column')
    column.innerHTML = ''

    const linksWrap = document.createElement('div')
    linksWrap.className = 'fm-mega-bettwasche__links'
    const ul = document.createElement('ul')
    ul.className = 'fm-mega-compact__items list-unstyled'
    links.forEach(function (link) {
      const li = document.createElement('li')
      li.appendChild(link)
      ul.appendChild(li)
    })
    linksWrap.appendChild(ul)
    column.appendChild(linksWrap)

    const media = buildMediaCard(entry?.media)
    if (media) column.appendChild(media)
    const promoCard = buildPromo(promo, { showImage: false })
    if (promoCard) column.appendChild(promoCard)
    applyGridFallback(
      column,
      'minmax(168px, 200px) minmax(148px, 172px) minmax(148px, 172px)',
    )
    return true
  }

  function enhanceCompactGrid(grid, entry) {
    if (grid.dataset.fmMegaReady === '1') return false
    const column = grid.querySelector('.mega-menu__column')
    if (!column) return false
    const links = collectLinks(column)
    if (!links.length) return false

    grid.dataset.fmMegaReady = '1'
    grid.classList.add('fm-mega-compact')
    stripThemeMedia(grid)
    column.classList.add('fm-mega-compact__column')
    column.innerHTML = ''

    const linksWrap = document.createElement('div')
    linksWrap.className = 'fm-mega-compact__links'
    const ul = document.createElement('ul')
    ul.className = 'fm-mega-compact__items list-unstyled'
    links.forEach(function (link) {
      const li = document.createElement('li')
      li.appendChild(link)
      ul.appendChild(li)
    })
    linksWrap.appendChild(ul)
    column.appendChild(linksWrap)

    const media = buildMediaCard(entry?.media)
    if (media) column.appendChild(media)
    applyGridFallback(column, 'minmax(200px, 240px) minmax(180px, 220px)')
    return true
  }

  function enhanceSimpleGrid(grid) {
    if (grid.dataset.fmMegaReady === '1') return false
    const column = grid.querySelector('.mega-menu__column')
    if (!column) return false
    const links = collectLinks(column)
    if (!links.length) return false

    grid.dataset.fmMegaReady = '1'
    grid.classList.add('fm-mega-simple')
    stripThemeMedia(grid)
    column.classList.add('fm-mega-simple__column')
    return true
  }

  function boot() {
    if (!MQ.matches) return
    const cfg = readConfig()
    const grids = document.querySelectorAll('.header-menu [data-menu-grid-id]')

    grids.forEach(function (grid) {
      const path = normalizePath(topLinkHref(grid))
      const entry = lookupMenuEntry(cfg, path)
      if (!entry) return

      const layout = entry.layout || 'compact'
      if (layout === 'wide') {
        const promo =
          cfg.promo && normalizePath(cfg.promo.widePath || '') === path ? cfg.promo : cfg.promo
        enhanceWideGrid(grid, entry, promo)
      } else if (layout === 'simple') {
        enhanceSimpleGrid(grid)
      } else if (entry.media) {
        enhanceCompactGrid(grid, entry)
      } else {
        enhanceSimpleGrid(grid)
      }
    })

    document.documentElement.classList.add('fm-nav-ready')
  }

  function scheduleBoot() {
    RETRY_MS.forEach(function (ms) {
      setTimeout(boot, ms)
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleBoot)
  } else {
    scheduleBoot()
  }

  MQ.addEventListener('change', scheduleBoot)
  document.addEventListener('shopify:section:load', scheduleBoot)
  document.addEventListener('shopify:section:select', scheduleBoot)

  new MutationObserver(function () {
    if (!MQ.matches) return
    const pending = document.querySelector('.header-menu [data-menu-grid-id]:not([data-fm-mega-ready="1"])')
    if (pending) boot()
  }).observe(document.documentElement, { childList: true, subtree: true })
})()
